import { render } from "./user-payment.vue?vue&type=template&id=c1f7fdca"
import script from "./user-payment.vue?vue&type=script&lang=js"
export * from "./user-payment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__